import React from 'react';
import MapView from '../discover/MapView';
import './DiscoverMapPopup.css';

function DiscoverMapPopup({ onClose }) {
  return (
    <div className="discover-map-popup">
      <div className="discover-map-popup-content">
        <MapView />
      </div>
    </div>
  );
}

export default DiscoverMapPopup;
